import React, { createContext, useContext, useState } from 'react';
import { ThreeDot } from 'react-loading-indicators';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <ThreeDot variant="bounce" color="#70B92F" size="medium" />
        </div>
      )}
    </LoadingContext.Provider>
  );
};
export const useLoading = () => useContext(LoadingContext);